<template>
    <header class="lg:hidden">
        <div class="bg-primary transition-shadow fixed w-full px-2 top-0 z-10 border-b bg-white">
            <div class="__sides relative flex items-center justify-between h-[5.5em] text-xs font-normal">
                <div @click="SET_SHOW_SIDE_NAV(!getshowSideNav)" class="flex items-center justify-center text-secondary lg:hidden cursor-pointer">
                    <svg class="h-7 w-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" /></svg>
                </div>
                <router-link to="/">
                    <img alt="Vue logo" src="/img/logo.png" class="h-9 sm:h-11 bg-transparent">
                </router-link>
                <div></div>
            </div>
        </div>
    </header>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {
        name: 'NavbarComponent',
        data() {
            return {
                imageLoaded: true
            }
        },
        computed:{
            ...mapGetters(['getUser','getLoadingUser', 'getshowSideNav', 'getNotificationQntPendente']),

            imageUrl(){
                return `${process.env.VUE_APP_URL_SERVER}/uploads/users/${this.getUser.image}`;
            }
        },
        methods: {
            ...mapMutations(['SET_SHOW_SIDE_NAV']),
        },
    }
</script>

<style>
    @media screen and (max-width: 768px) {
        .center-title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .__link {
        text-decoration: none;
        position: relative;
    }
    .__link::after {
        bottom: -4px;
        content: "";
        display: block;
        height: 2px;
        left: 0;
        position: absolute;
        background: rgb(31 41 55);
        opacity: 0.6;
        transition: width 0.3s ease 0s, opacity 0.3s ease 0s;
        width: 0;
    }
    .__link:hover::after {
        width: 100%;
        opacity: 0.9;
    }
</style>